import { EOrganizedBy } from 'detailsv2/structure';
import yup from 'utils/yup';

import { requiredFieldErrorMessage, wrongTimeFormatError } from '../../constants';
import { optionalTimeFormatValidation, optionalTimeLengthValidation } from '../../functions';
import { optionToRoomAdapter } from '../functions';

export const accommodationValidationSchema = (organizedBy: EOrganizedBy) => {
  const formFields: any = {
    attachedPage: yup.object().shape({ name: yup.string().required() }),
    data: yup.object().shape({
      isAlternate: yup.boolean(),
      checkIn: yup
        .string()
        .test('check-in-time-len', wrongTimeFormatError, optionalTimeLengthValidation)
        .test('is-check-in-time-valid', wrongTimeFormatError, optionalTimeFormatValidation),
      checkOut: yup
        .string()
        .test('check-out-time-len', wrongTimeFormatError, optionalTimeLengthValidation)
        .test('is-check-out-time-valid', wrongTimeFormatError, optionalTimeFormatValidation),
      confirmationNumber: yup.string(),
      contactInfo: yup.string(),
      rooming: yup.array().transform((arr: any[]) => arr.map(optionToRoomAdapter)),
      roomBasis: yup.string().nullable(),
      website: yup.string().trim().websiteURL(),
      displaySettings: yup.object().shape({
        checkIn: yup.string().required(requiredFieldErrorMessage),
        overnight: yup.string().required(requiredFieldErrorMessage),
        checkOut: yup.string().required(requiredFieldErrorMessage),
      }),
    }),
  };

  if (organizedBy === EOrganizedBy.Date) {
    formFields.datesRange = yup.object().shape({
      start: yup.string().required('Please fill in this field').nullable(),
      end: yup.string().nullable(),
    });
  }

  if (organizedBy === EOrganizedBy.Day) {
    formFields.daysRange = yup.object().shape({
      start: yup.number().required('Please fill in this field').nullable(),
      end: yup.number().nullable(),
    });
  }

  return yup.object().shape({
    ...formFields,
  });
};
